import boletaApi from "./boletaApi";

export const getCompaniesWithEmployees = async () => {
  try {
    return await boletaApi.get("/getCompaniesWithEmployees");
  } catch (error) {
    const { response } = error;
    return response;
  }
};
